/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchLabels({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/rating/translations", data)
        .then((response) => {
          commit('SET_LABELS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  updateTranslation({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/rating/updatetranslation", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
